import { ParamMap } from '@angular/router';

import { PayeeInfo } from './+state/commission-invoice-create.store';
import { ExpertDTO } from '../../../types/expert.types';
import { OrganizationDTO } from '../../../types/organization.types';
import { COMMISSION_INVOICE_PAYEE_TYPE, CommissionInvoicePayeeType } from '../../../shared/definitons';

export interface InvoiceCreateParams {
  payeeType: CommissionInvoicePayeeType | null;
  payeeId: string | null;
  payeeName: string | null;
  commissionId: string | null;
  periodStart: string | null;
  periodEnd: string | null;
  notes: string | null;
}

/**
 * Parses route query params into a typed InvoiceCreateParams object
 * @param paramMap - ParamMap from ActivatedRoute snapshot
 * @returns InvoiceCreateParams
 */
export function parseInvoiceCreateParams(paramMap: ParamMap): InvoiceCreateParams {
  return {
    payeeType: paramMap.get('payee_type') as CommissionInvoicePayeeType | null,
    payeeId: paramMap.get('payee_id'),
    payeeName: paramMap.get('payee_name'),
    commissionId: paramMap.get('commission_id'),
    periodStart: paramMap.get('period_start'),
    periodEnd: paramMap.get('period_end'),
    notes: paramMap.get('notes'),
  };
}

export const CREATE_STEP = {
  Payee: 1,
  Commissions: 2,
} as const;

export type CreateStep = (typeof CREATE_STEP)[keyof typeof CREATE_STEP];

export const CREATE_STEPS: ReadonlyArray<{ value: CreateStep; label: string }> = [
  { value: CREATE_STEP.Payee, label: 'Payee' },
  { value: CREATE_STEP.Commissions, label: 'Commissions' },
];

export class InvoiceStepsManager {
  constructor(
    private readonly getStep: () => CreateStep,
    private readonly setStep: (step: CreateStep) => void
  ) {}

  isPayeeStep(): boolean {
    return this.getStep() === CREATE_STEP.Payee;
  }

  isCommissionsStep(): boolean {
    return this.getStep() === CREATE_STEP.Commissions;
  }

  goToPayee(): void {
    this.setStep(CREATE_STEP.Payee);
  }

  goToCommissions(): void {
    this.setStep(CREATE_STEP.Commissions);
  }
}

export function buildPayeeInfo(
  payeeType: CommissionInvoicePayeeType,
  expert: ExpertDTO | null,
  org: OrganizationDTO | null,
  companyPayeeName: string
): PayeeInfo | null {
  if (payeeType === COMMISSION_INVOICE_PAYEE_TYPE.ExpertIndividual) {
    if (!expert) return null;
    return {
      payeeType: COMMISSION_INVOICE_PAYEE_TYPE.ExpertIndividual,
      payeeId: expert.id,
      payeeName: expert.full_name ?? expert.email,
    };
  }
  if (payeeType === COMMISSION_INVOICE_PAYEE_TYPE.ExpertOrganization) {
    if (!org) return null;
    return {
      payeeType: COMMISSION_INVOICE_PAYEE_TYPE.ExpertOrganization,
      payeeId: org.id,
      payeeName: org.name,
    };
  }
  return {
    payeeType: COMMISSION_INVOICE_PAYEE_TYPE.Company,
    payeeId: '',
    payeeName: companyPayeeName || 'SNDBX International',
  };
}
